export default function Dot({width,height}){
return(<svg width={width} height={height} viewBox="0 0 6 6" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
<circle cx="3" cy="3" r="3" />
</svg>)
}